import { Outlet } from 'react-router-dom';
import { ToastNotification, useModalToggle } from '@make-software/tg-mini-app-ui';
import { useTheme } from 'styled-components';

import { AuthorizedLayout } from '@/widgets';
import { InstallToHomeScreenModal, useInitializeTaskManager, formatSuccessTaskToastMessage } from '@/shared';
import { TaskModal, TaskClaimModalHost } from '@/features';
import SuccessIcon from '@/shared/assets/icons/ic-checkmark-fill.svg';
import DangerIcon from '@/shared/assets/icons/ic-close-fill.svg';

interface ProtectedRoutesProps {
  withoutFooter?: boolean;
  hasBackButtonTo?: number | string;
}
export const ProtectedRoutes = ({ withoutFooter, hasBackButtonTo }: ProtectedRoutesProps) => {
  useInitializeTaskManager();
  const { open, closeModal } = useModalToggle('install_to_home_screen');
  const theme = useTheme();

  return (
    <AuthorizedLayout
      title={'CSPR.fans'}
      hasFooter={!withoutFooter}
      hasBackButtonTo={hasBackButtonTo}>
      <Outlet />
      <TaskModal />
      <TaskClaimModalHost />
      <ToastNotification
        fontFamily={theme.typography.fontFamily.sans}
        successIconSrc={SuccessIcon}
        dangerIconSrc={DangerIcon}
        textColor="#fff"
        formatSuccessMessage={formatSuccessTaskToastMessage}
        successColor="linear-gradient(0deg, rgba(49, 222, 145, 0.20), rgba(49, 222, 145, 0.20)), #30313B"
        errorColor="linear-gradient(0deg, rgba(251, 111, 106, 0.20), rgba(251, 111, 106, 0.20)), #30313B"
      />
      <InstallToHomeScreenModal
        openModal={open}
        handleCloseModal={closeModal}
        externalUrl={window.location.origin}
      />
    </AuthorizedLayout>
  );
};
